export const locale = {
  lang: "PLPL",
  data: {
    loginButton: "Login",
    userName: "Nazwa użytkownika",
    emailCode: "Kod e-mail",
    pass: "Hasło",
    remember: "Pamiętaj mnie",
    forgotPass: "Zapomniałem hasła",
    modules: "Moduły",
    generic: "Ogólny",
    search: "Szukaj",
    logout: "Wyloguj",
    waitingJob: "Moje oczekujące prace",
    myStarted: "Zacząłem",
    myIncluded: "Jestem włączony",
    myCompleted: "Zakończone prace",
    jobListMessageArea: "Obszar wiadomości listy zadań",
    jobList: "Lista zadań",
    formNo: "Numer formularza",
    status: "Status",
    starter: "Rozpoczęto",
    generateLink: "Wygeneruj link",
    assigned: "Przydzielony",
    timeoutDate: "Przekroczono limit czasu Tar.",
    startDate: "Data rozpoczęcia",
    processing: "Przetwarzanie",
    you: "Ty",
    history: "Historia",
    description: "Opis",
    date: "Data",
    growShrink: "Wzrost/Zmniejszenie",
    close: "Zamknąć",
    gridReset: "Zresetuj ustawienia siatki",
    columnSelect: "Wybór kolumny",
    jobName: "Nazwa stanowiska",
    keyword: "Słowo kluczowe",
    completion: "Ukończenie",
    all: "Wszystko",
    completedDate: "Data zakończenia",
    completions: "Zakończony",
    ongoing: "Bieżący",
    formName: "Nazwa formularza",
    sunday: "Niedziela",
    monday: "Poniedziałek",
    tuesday: "Wtorek",
    wednesday: "Środa",
    thursday: "Czwartek",
    friday: "Piątek",
    saturday: "Sobota",
    pdfExport: "Eksportuj PDF",
    sendPassword: "Wyślij moje hasło",
    assignedDate: "Data zadania",
    events: "Wydarzenia",
    new: "Nowy",
    save: "Ratować",
    formula: "Formuła",
    selectDataSource: "Wybierz źródło danych",
    requiredField: "Pole wymagane",
    makeRequiredField: "Ustaw pole jako wymagane",
    suffix: "Przyrostek",
    valueColumn: "Kolumna wartości",
    showLength: "Pokaż liczbę zadań w kolumnach",
    clearButton: "Przycisk Wyczyść",
    allCaps: "Wszystkie wielkie litery",
    autoAsc: "Automatyczne zwiększanie",
    width: "Szerokość",
    length: "Długość",
    functions: "Funkcje",
    selectElement: "Wybierz element",
    selectColumn: "Wybierz kolumnę",
    edit: "Redagować",
    changeEventActions: "Zmień akcje zdarzeń",
    barcode: "Kod kreskowy",
    systemInfo: "Informacje o systemie",
    prefix: "Prefiks",
    max: "Maksymalny",
    showMinMaxInfo: "Wyświetlanie informacji minimalnych i maksymalnych",
    selectUser: "Wybierz użytkownika",
    spinButton: "Przycisk Spin",
    numberIncDecButton: "Przycisk zwiększania/zmniejszania liczby",
    decimal: "Liczba dziesiętna",
    numeral: "Numer",
    wrongFormat: "wpisałeś zły format",
    height: "Wysokość",
    microphone: "Mikrofon",
    notifyDataReset: "Resetowanie danych",
    data: "Dane",
    dynamicData: "Dane dynamiczne",
    manualData: "Dane ręczne",
    selectDataGrid: "Wybierz siatkę danych",
    overrideUserChange: "Zmiażdż zmiany użytkownika",
    textColumn: "Kolumna tekstowa",
    makeInitialValue: "Domyślna wartość początkowa",
    undo: "Anulować",
    copy: "Kopia",
    preview: "Zapowiedź",
    delete: "Usuwać",
    cancel: "Anulować",
    languageSettings: "Ustawienia językowe",
    messageSqlLinkDeleted: "Ponieważ dodałeś dane ręcznie, skrypt SQL i adres linku zostaną usunięte! Kontynuować?",
    messageSqlLinkDeletedForMenu: "Wybranie opcji „Dane” w menu spowoduje usunięcie pliku skryptu SQL i adresu łącza! Czy chcesz kontynuować?",
    permissions: "Uprawnienia",
    objectid: "Identyfikator obiektu",
    fontSize: "Rozmiar czcionki",
    fontWidth: "Szerokość tekstu",
    fontStyle: "Styl czcionki",
    labelMode: "Tryb etykiety",
    normal: "Normalna",
    static: "Statyczny",
    floating: "Ruchomy",
    outside: "Poza",
    underline: "Podkreślać",
    textColor: "Kolor tekstu",
    visibility: "Widoczność",
    textAlignment: "Wyrównanie tekstu",
    settings: "Ustawienia",
    messageUnsaved: "Czy na pewno chcesz wyjść bez zapisywania zmian?",
    warning: "Ostrzeżenie!",
    userAuthorizations: "Autoryzacje użytkownika",
    formPreferences: "Preferencje formularza",
    formOpeningevent: "Formularz wydarzenia otwartego",
    formOpenLocationEvent: "Wydarzenie współrzędne otwarcia formularza",
    enableFormOpenLocationEvent: "Zapisz współrzędne po otwarciu formularza",
    latitude: "Szerokość",
    longitude: "Długość geograficzna",
    chooseConnectionAddress: "Wybierz adres połączenia",
    selectPriorty: "Wybierz priorytet",
    loadingEditor: "Ładowanie edytora ...",
    showAddButton: "Pokaż przycisk Dodaj wiersz",
    update: "Aktualizacja",
    connectionID: "Identyfikator połączenia",
    formPreview: "Podgląd formularza",
    nameDisplayedform: "Nazwa wyświetlanego formularza",
    formNamevariable: "Zmienna nazwy formularza",
    category: "Kategoria",
    formColor: "Kolor formularza",
    generalForm: "Formularz ogólny",
    saveForm: "Zapisz formularz",
    messageNeworupdate: "Zmiany wprowadzone w istniejącym formularzu zostaną usunięte. Kontynuować?",
    messageDelete: "Czy na pewno chcesz usunąć formularz?",
    toastDeleted: "Formularz usunięty",
    toastError: "Przepraszamy, wystąpił błąd podczas przetwarzania",
    alertDifferentID: "To identyfikator jest już używany gdzie indziej. Proszę podać inny identyfikator.",
    confirmChanges: "Potwierdź zmiany",
    toastUserpermission: "Użytkownik nie ma uprawnień do projektowania formularzy.",
    toastCodeeditor: "Codeeditor już istnieje",
    messageDeletesure: "Elementy w tym komponencie zostaną usunięte",
    messageSure: "Jesteś pewien?",
    successful: "Udany",
    rrror: "Błąd",
    toastFormupdate: "Formularz zaktualizowany",
    toastMistake: "Przepraszamy, wystąpił błąd podczas przetwarzania",
    toastSaved: "Zapisano",
    toastCopied: "Skopiowano",
    toastEmptyFormMessage: "Nie dodano jeszcze żadnych elementów formularza",
    toastGiveName: "Proszę nadać formularzowi nazwę",
    toastGiveVariableName: "Proszę podać nazwę zmiennej nazwy formularza",
    toastVariableNameNumberWarning: "Nazwa zmiennej nie może zaczynać się od liczby",
    formCopy: "Kopiuj formularz",
    messageButtonDelete: "Czy na pewno chcesz usunąć przycisk?",
    noDataFound: "Nie znaleziono danych",
    language: "Język",
    filterDatagrid: "Filtrowanie siatki danych",
    addManualData: "Dodawanie danych ręcznych w czasie wykonywania",
    dateFormat: "Format daty",
    messageSqlLinkDelete: "Ponieważ dodałeś dane ręcznie, skrypt SQL i adres linku zostaną usunięte! Kontynuować?",
    timeOption: "Opcja zegara",
    defaultTodaysDate: "Niech domyślną datą będzie dzisiejsza data",
    dateRange: "Zakres dat",
    minToday: "Minimum dzisiaj",
    maxToday: "Maksymalnie dzisiaj",
    dateRangeDay: "Zakres dat (dzień)",
    enterDateRangeValue: "Wprowadź wartość zakresu dat",
    imageIdColumn: "Kolumna ID",
    statusSettings: "Ustawienia statusu",
    active: "Aktywny",
    passive: "Pasywny",
    enable: "Włączony",
    disable: "Wyłączony",
    visible: "Widoczny",
    invisible: "Niewidzialny",
    items: "Rzeczy",
    showItems: "Wyświetl elementy",
    array: "Szyk",
    letLabelAppear: "Pokaż etykietę",
    add: "Dodać",
    horizontal: "Poziomy",
    vertical: "Pionowy",
    text: "Tekst",
    alertFillRequiredFields: "Proszę wypełnić wymagane pola",
    alertSignatureField: "Pole podpisu nie może być puste",
    messageApproveTransaction: "Czy wyrażasz zgodę?",
    button: "Przycisk",
    reasonforRefusal: "Powód odrzucenia",
    enterReasonRejection: "Wprowadź powód odrzucenia",
    reject: "Odrzucić",
    addDeleteButton: "Przycisk Dodaj/Usuń",
    cellBackgroundColors: "Kolory komórek",
    showCellActionButtons: "Pokaż przyciski akcji komórek",
    cellBackgroundColor: "Kolor tła komórki",
    cell: "Komórka",
    cellPreview: "Podgląd komórki",
    clear: "Jasne",
    componentBackgroundColor: "Kolor tła komponentu",
    showBorder: "Pojawia się granica",
    buttons: "Pikolak",
    clean: "Jasne",
    buttonSettings: "Ustawienia przycisków",
    saveLocation: "Zapisz lokalizację",
    paymentButton: "Przycisk płatności",
    paymentProvider: "Dostawca płatności",
    price: "Cena",
    numberOfInstallments: "Liczba rat",
    descriptionField: "Pole opisu",
    current: "Aktualny",
    currentForm: "Aktualna forma",
    name: "Nazwa",
    surname: "Nazwisko",
    country: "Kraj",
    city: "Miasto",
    address: "Adres",
    authorizations: "Autoryzacje",
    users: "Użytkownicy",
    user: "Użytkownik",
    givePermission: "Autoryzować",
    otherPermission: "Inne uprawnienia",
    groups: "Grupy",
    group: "Grupa",
    saveandSend: "Zapisz i wyślij",
    approve: "Zatwierdzić",
    sendBack: "Odesłać",
    deslineAndEnd: "Odrzuć i zakończ",
    complete: "Zakończony",
    blue: "Niebieski",
    gray: "Szary",
    green: "Zielony",
    red: "Czerwony",
    left: "Lewy",
    right: "Prawidłowy",
    color: "Kolor",
    symbol: "Symbol",
    position: "Pozycja",
    action: "Działanie",
    total: "Całkowity",
    filePath: "Ścieżka pliku",
    fileName: "Nazwa pliku",
    fileUpload: "Przesyłanie plików",
    choose: "Wybierać",
    updateData: "Aktualizacja danych",
    show: "Pokazywać",
    columns: "Kolumny",
    changeEvent: "Zmień wydarzenie",
    columnSettings: "Ustawienia kolumn",
    columnName: "Nazwa kolumny",
    deleteColumn: "Usuń kolumnę",
    columnSqlScripts: "Skrypty SQL dla kolumn",
    imageNameColumn: "Kolumna nazwy pliku",
    columnLanguageSetting: "Ustawienia języka kolumny",
    dataSource: "Źródło danych",
    filter: "Filtr",
    reset: "Nastawić",
    column: "Kolumna",
    image: "Obraz",
    searchLocation: "Wyszukaj lokalizację...",
    draggable: "Przeciągany",
    usersCanChange: "Użytkownicy mogą zmieniać",
    multiMarker: "Wieloznacznikowy",
    markerLimit: "Limit punktów (0: Brak limitu)",
    meetingType: "Typ spotkania",
    meetingName: "Nazwa spotkania",
    loadingFiles: "Ładowanie plików...",
    fileSizeExceeded: "Przekroczono rozmiar pliku",
    filesLoaded: "Załadowano pliki",
    condition: "Stan",
    value: "wartość",
    connectionAddress: "Adres połączenia",
    imageTypeColumn: "Kolumna Typ pliku",
    visibleColumn: "Widoczna kolumna",
    selectionMode: "Tryb wyboru",
    selectMode: "Wybierz tryb",
    datagridFiltering: "Filtrowanie siatki danych",
    imageDataColumn: "Kolumna pliku",
    selectDataColumn: "Wybierz kolumnę siatki danych",
    dataFormat: "Format danych",
    photoPreview: "Podgląd zdjęć",
    videoPreview: "Podgląd wideo",
    displayPhoto: "Wyświetl zdjęcie",
    displayVideo: "Wyświetl wideo",
    imageColumn: "Kolumna obrazu",
    videoColumn: "Kolumna wideo",
    columnNameAppear: "Nazwa kolumny do wyświetlenia",
    selected: "Wybrany",
    inStock: "W magazynie",
    messageSave: "Czy na pewno chcesz zapisać zmiany?",
    gallery: "Galeria",
    dollar: "dolar",
    sterling: "szterling",
    underPhoto: "Pod zdjęciem",
    topPhoto: "Zdjęcie na górze",
    byCategory: "Według kategorii",
    dashboardShowHide: "Pokaż/Ukryj pulpit nawigacyjny",
    showDetail: "Zobacz szczegóły",
    hideDetail: "Ukryj szczegóły",
    decrease: "Zmniejszenie",
    increase: "Zwiększyć",
    watch: "oglądać",
    watchMovie: "Obejrzyj film",
    noRecordsFound: "Nie znaleziono żadnych rekordów!",
    appearance: "Wygląd",
    numberofColumns: "Liczba kolumn",
    pagingRecords: "Rekordy stronicowania",
    detailLocation: "Szczegółowa lokalizacja",
    hideImages: "Ukryj obrazy",
    quantityCategoryDisable: "Wyłącz kategorię, gdy ilość wzrasta",
    general: "Ogólny",
    idColumn: "Kolumna identyfikatorów",
    availableQuantity: "Dostępna ilość",
    categoryColumn: "Kolumna kategorii",
    photoColumn: "Kolumna ze zdjęciami",
    titleColumn: "Kolumna tytułu",
    priceColumn: "Kolumna cenowa",
    updatablePrice: "Cena do aktualizacji",
    videoGallery: "Galeria wideo",
    uniqueComponent: "Unikalny komponent",
    showVariant: "Pokaż wariant",
    transferTotalAmount: "Całkowita kwota przelewu",
    title: "Tytuł",
    hide: "Ukrywać",
    detail: "Szczegół",
    priceQuery: "Zapytanie o cenę",
    quantityQuery: "Zapytanie o ilość",
    uniqueComponentError: "Błąd unikalnego komponentu",
    joinColumn: "Dołącz do kolumny",
    nameColumn: "Kolumna Nazwa",
    variantScript: "Skrypt wariantowy",
    variantImages: "Obrazy wariantowe",
    variantJoinColumn: "Kolumna dołączenia wariantu",
    showAll: "Pokaż wszystko",
    showSelected: "Pokaż wybrane",
    showByCategory: "Pokaż według kategorii",
    showInStock: "Pokaż, co jest w magazynie",
    notYetAdded: "Jeszcze nie dodano",
    added: "W dodatku",
    startingDate: "Data rozpoczęcia",
    endDate: "Data zakończenia",
    themeFeatures: "Funkcje motywu",
    menu: "Menu",
    selectMenu: "Wybierz Menu",
    selectSubmenu: "Wybierz podmenu",
    selectMenuBrowser: "Wybierz przeglądarkę menu",
    nameElement: "Nazwa elementu",
    subject: "temat",
    picture: "zdjęcie",
    pictureElement: "Element obrazu",
    startingDateElement: "Element daty początkowej",
    endDateElement: "Element daty końcowej",
    usersCanEdit: "Użytkownicy mogą edytować",
    thisPropertyCant: "Tej właściwości NIE MOŻNA używać, jeśli dane są pobierane z SQL",
    calendarDisplay: "Właściwości wyświetlania kalendarza",
    monthly: "Miesięczny",
    generalDisplayLunarDays: "Ogólny wyświetlacz dni księżycowych",
    agenda: "Porządek obrad",
    listofWeeklyEvents: "Lista wydarzeń tygodniowych",
    weekly: "Tygodnik",
    weekend: "Weekend",
    generalDisplayWeekDays: "Ogólny wyświetlacz dni powszednich",
    showWeekendDaysWhileWeekdays: "Pokaż dni weekendowe, pokazując dni powszednie",
    daily: "Codziennie",
    listofDailyEvents: "Lista wydarzeń codziennych",
    startTime: "Czas rozpoczęcia",
    endTime: "Czas końcowy",
    changeDefaultColor: "Zmień domyślne kolory",
    weekdayColor: "Kolor dnia powszedniego",
    weekendColor: "Kolor weekendowy",
    eventColor: "Kolor wydarzenia",
    groupBySql: "Grupuj według SQL",
    groupColumnName: "Nazwa kolumny grupy",
    assignedColumnName: "Przypisana nazwa kolumny",
    taskPriortiyColumnName: "Nazwa kolumny priorytetu zadania",
    taskSubjectColumnName: "Nazwa kolumny tematu zadania",
    taskDetailColumnName: "Nazwa kolumny szczegółów zadania",
    taskQuery: "Zapytanie o zadanie",
    taskKeyExpression: "Wyrażenie kluczowe zadania",
    taskTitleExpression: "Wyrażenie tytułu zadania",
    taskStartDateExpression: "Wyrażenie daty rozpoczęcia zadania",
    taskEndDateName: "Nazwa daty zakończenia zadania",
    taskParentExpression: "Wyrażenie nadrzędne zadania",
    taskProgressExpression: "Wyrażenie postępu zadania",
    taskColorExpression: "Wyrażenie koloru zadania",
    taskConnections: "Połączenia zadań",
    diagramClear: "Czy na pewno chcesz wyczyścić diagram? Tej czynności nie można cofnąć.",
    uniqueComponentMenuCloneWarning: "Przed kopiowaniem należy zmienić unikalny komponent.",
    filesLoading: "Ładowanie plików...",
    couldnotbeLoaded: "nie można załadować.",
    fileSizeLimit: "Limit rozmiaru pliku",
    filesUploaded: "Przesłane pliki",
    filesWillDeleted: "Pliki zostaną usunięte!",
    filesSureDelete: "Czy na pewno chcesz usunąć pliki?",
    fileDelete: "Czy chcesz usunąć plik?",
    uploadedPhotos: "#VALUE!",
    maxSize: "Maksymalny rozmiar",
    center: "Średni",
    size: "Rozmiar",
    canItBeUpdated: "zostanie zaktualizowany po instalacji?",
    uploadedFiles: "Przesłane pliki",
    type: "Typ",
    showdeleteOldData: "Opcje usuwania starych danych",
    videoBrowser: "Twoja przeglądarka nie obsługuje tagu wideo.",
    deleted: "Usunięto",
    theseComponentElementsDeleted: "Te elementy składowe zostaną usunięte.",
    invalidTarget: "Nieprawidłowy cel",
    ridge: "Linia prosta",
    dotted: "Kropka",
    dashed: "Pasiasty",
    addRowColumn: "Dodaj wiersz/kolumnę",
    dataPagingShow: "Pobierz dane jako strony",
    borderType: "Typ obramowania",
    maxCharacters: "Maksymalna liczba znaków",
    edgeThickness: "Grubość krawędzi",
    lineSpacing: "Odstępy między wierszami",
    settingsRow: "Ustawienia wiersza/kolumny",
    addRow: "Dodaj wiersz",
    deleteRow: "Usuń wiersz",
    rowPermission: "Uprawnienia wiersza",
    addTabs: "Dodaj zakładki",
    deletePanel: "Usuń panel",
    tabPermission: "Uprawnienia do karty",
    addPanel: "Dodaj panel",
    panelPermission: "Uprawnienia panelu",
    backgroundColor: "Kolor tła",
    saveAndCloseChildForm: "Zapisz i zamknij ten formularz podrzędny podczas otwierania nowego formularza",
    icon: "Symbol",
    selectForm: "Wybierz formularz",
    fontColor: "Kolor czcionki",
    minCharacters: "Minimalna liczba znaków",
    generalCategory: "Kategoria ogólna",
    removeRow: "Czy na pewno chcesz usunąć rekord?",
    send: "wysłać",
    declineFinish: "Odrzuć i zakończ",
    finish: "Skończyć",
    noData: "Brak danych",
    createEditMenu: "Utwórz/Edytuj menu",
    addNewBreakdown: "Dodaj nową awarię",
    addForm: "Dodaj formularz",
    addBottomBreak: "Dodaj przerwę dolną",
    addNode: "Dodaj węzeł",
    topCategory: "Najwyższa kategoria",
    explanation: "Opis",
    browserTitle: "Tytuł przeglądarki",
    formTitle: "Tytuł formularza",
    addSqlColumn: "Dodaj kolumnę SQL",
    formBg: "Tło formularza",
    codeEditor: "Edytor kodu",
    authorityType: "Typ autoryzacji",
    viewOnly: "Tylko do przeglądania",
    dark: "Ciemny",
    white: "Biały",
    hightBlack: "Czarny",
    run: "Uruchomić",
    fileLink: "Link do pliku",
    givePasswordToTheLink: "Podaj hasło do linku",
    giveTheLinkAnExpirationDate: "Podaj datę wygaśnięcia linku",
    rowColor: "Kolor wiersza",
    operator: "Operator",
    flowOfForm: "Przepływ formularza",
    columnWidth: "Szerokość kolumny",
    alignLeft: "Wyjustuj do lewej",
    alignRight: "Wyjustuj do prawej",
    alignButton: "Przycisk wyrównania",
    imageTableNameColumn: "Nazwa tabeli",
    uploadBg: "Prześlij tło",
    selectFile: "Wybierz plik",
    dropFile: "Upuść plik tutaj",
    alwaysRoundUp: "Zawsze zaokrąglaj w górę",
    alwaysRoundBot: "Zawsze zwijaj w dół",
    default: "Domyślny",
    deleteOldDataTable: "Czy usunąć stare dane z tabeli?",
    deleteOldData: "Usunąć stare dane?",
    integer: "Liczba całkowita",
    double: "Liczba dziesiętna",
    pleaseFillFields: "Proszę wypełnić wymagane pola.",
    toastColumnNameNumber: "Nazwa kolumny nie może zaczynać się od liczby",
    areYouSure: "Jesteś pewien?",
    columnDeleted: "Kolumna zostanie usunięta",
    allColumnDeleted: "Wszystkie kolumny zostaną usunięte",
    idCantStartNumber: "Identyfikator nie może zaczynać się od cyfry",
    uploadFile: "Prześlij plik",
    fileViewer: "Przeglądarka plików",
    ok: "Dobra",
    map: "Mapa",
    editPanel: "Panel edycji",
    filterColumnName: "Nazwa kolumny filtra",
    hintExamples: "Całkowita kwota, przykład: Maas",
    columnLanguageSettings: "Ustawienia języka kolumny",
    fileColumn: "Kolumna pliku",
    fileNameColumn: "Kolumna nazwy pliku",
    extensionColumn: "Kolumna rozszerzająca",
    multipleSelection: "Wybór wielokrotny",
    addSelectionsRows: "Dodaj selekcje jako wiersze",
    mapSettings: "Ustawienia mapy",
    formatAndFeatures: "Format i funkcje",
    enterDateRange: "Wprowadź wartość zakresu dat",
    filesCanUploadedUsers: "Użytkownicy mogą przesyłać pliki",
    barcodeColumn: "Kolumna kodu kreskowego",
    autoAscend: "Automatyczne wznoszenie",
    roundType: "Typ zaokrąglenia",
    font: "Chrzcielnica",
    columnProcess: "Operacja kolumnowa",
    exportColumnTotal: "Suma kolumny eksportu",
    outsideElementDisabled: "Wyłącz elementy zewnętrzne",
    chat: "Pogawędzić",
    languages: "Języki",
    display: "Obraz",
    enterYourComment: "Wpisz swój komentarz",
    comment: "Uwagi",
    fileUploaded: "przesłanych sztuk",
    pdfViewIsButton: "Pokaż jako przycisk",
    takeScreenshot: "Zrób zrzut ekranu",
    alertText: "Tekst alarmu",
    clearButtonVisible: "Pokaż przycisk Wyczyść",
    allText: "Wszystko",
    letter: "Tylko list",
    letterandnumber: "Litera i cyfra",
    letterandsymbol: "Litera i symbol",
    numberandsymbol: "Liczba i symbol",
    showIDColumn: "Pokaż kolumnę ID",
    showCopyButton: "Pokaż przycisk Kopiuj",
    showDeleteButton: "Pokaż przycisk Usuń",
    showCheckboxButton: "Pokaż przycisk pola wyboru",
    autoRowHeight: "Automatyczna wysokość rzędu",
    exportImport: "Formularz importu/eksportu",
    export: "Eksport",
    import: "Import",
    toastImport: "Import formularza zakończony.",
    warningApproveImport: "Potwierdź operację po wprowadzeniu niezbędnych zmian. Zaimportowanie formularza spowoduje zamknięcie aktualnie otwartego formularza.",
    defaultTodaysDateWithTime: "Domyślnie jest to dzisiejsza data i godzina",
    filterVisible: "Pokaż filtrowanie kolumn",
    updatetableMaxQuantity: "Maksymalna ilość możliwa do aktualizacji",
    hideQuantity: "Ukryj wybór ilości",
    disableQuantityTextbox: "Wyłącz wpisywanie ilości",
    multiplesOfQuantity: "Zwiększ/zmniejsz wielokrotności ilości",
    justnumber: "Tylko liczba",
    paymentHourWarning: "Nie można płacić poza godzinami otwarcia kasy.",
    addColumn: "Dodaj kolumnę",
    mailSettings: "Opcje poczty",
    newTaskMailDetail: "Tekst wiadomości e-mail, który zostanie wysłany po przypisaniu nowego zadania",
    updateTaskMailDetail: "Tekst wiadomości e-mail, który zostanie wysłany po edycji zadania",
    deleteTaskMailDetail: "Tekst wiadomości e-mail, która zostanie wysłana po usunięciu zadania",
    completeTaskMailDetail: "Tekst wiadomości e-mail, która zostanie wysłana po zakończeniu zadania",
    taskOnDropMail: "Tekst wiadomości e-mail, która zostanie wysłana po przeniesieniu zadania",
    selectSMTP: "Wybierz adres SMTP",
    taskCreator: "Osoba przypisana do zadania",
    taskEndDate: "Data wygaśnięcia zadania",
    tags: "Tagi",
    taskStartDate: "Data rozpoczęcia zadania",
    taskAssigned: "Osoba przypisana do zadania",
    taskDetail: "Szczegóły zadania",
    taskSubject: "Tytuł zadania",
    taskPri: "Priorytet zadania",
    taskEdit: "Aktualizacja zadania",
    addTask: "Dodaj zadanie",
    taskStatus: "Status zadania",
    excelExportSettings: "Ustawienia eksportu programu Excel",
    excelExportRequiredColor: "Wymagany kolor kolumny pola",
    allDataExcelExport: "Eksportuj dane jako Excel",
    warningApproveImportReport: "Potwierdź operację po wprowadzeniu niezbędnych zmian. Zaimportowanie raportu spowoduje zamknięcie aktualnie otwartego raportu.",
    reportName: "Nazwa raportu",
    emptyReportName: "Proszę dodać nazwę raportu z prawej strony.",
    old: "stary",
    upperNode: "Górna refrakcja",
    pdfViewStaticPdf: "Pokaż naprawiony plik",
    actions: "Akcje",
    loading: "Załadunek",
    exportDataToExcell: "Eksportuj wszystkie dane do programu Excel",
    showRefreshIcon: "Przycisk Odśwież",
    headerFilter: "Filtr nagłówka",
    filterRowVisible: "Pole wyszukiwania pojawia się w kolumnie",
    password: "Hasło",
    categories: "Kategorie",
    pressEnter: "Naciśnij Enter",
    historyColumnValue: "Kolumna historii danych",
    hideMobile: "Ukryj na urządzeniu mobilnym",
    align: "Wyrównanie",
    theme: "Temat",
    info: "Informacje",
    showTitle: "Pokaż tytuł",
    purple: "Fioletowy",
    brown: "Brązowy",
    yellow: "Żółty",
    turnOnComments: "Otwórz komentarze",
    showContent: "Pokaż zawartość",
    canBeHidden: "Można ukryć",
    allowEdit: "Zezwól na edycję",
    allowDelete: "Zezwalaj na usuwanie",
    allowAdd: "Zezwól na dodawanie",
    allowCopy: "Zezwól na kopiowanie",
    toastDeleteErrorMessage: "Ten komponent jest używany w skryptach preferencji formularzy. Nie można go usunąć.",
    formOpeningMultiElementEvent: "Wydarzenie wieloelementowe otwierające formularz",
    resetDatagridLocalSettings: "Zresetuj ustawienia regionalne Datagrid",
    loginP1: "River oferuje holistyczny system pamięci, który jest integralną częścią pamięci korporacyjnej. Zawiera on informacje takie jak przeszłe doświadczenia, sukcesy, porażki, wyciągnięte wnioski, kulturę i wartości organizacji lub instytucji, które mogą być wykorzystane jako źródło odniesienia do przyszłych decyzji i działań. Informacje te dotyczą procesów, wiedzy pracowników, doświadczeń klientów, rozwoju produktów i usług oraz wielu innych aspektów. Informacje te będą stanowić podstawę przyszłych celów i strategii firmy.",
    loginP2: "River pomaga Twojej firmie sprawniej i efektywniej realizować procesy biznesowe dzięki swojej strukturze internetowej i zaawansowanej, natywnej aplikacji mobilnej. Wszystko, do czego potrzebujesz dostępu, jest tak blisko Ciebie, jak Twój komputer, tablet lub smartfon.",
    loginP3: "Wykresy Kanban i Gantta to niezwykle przydatne narzędzia do wizualizacji projektu lub przepływu pracy. Zapewniają wizualną reprezentację zadań, ich aktualnego statusu oraz przepływu pracy na różnych etapach działalności. Ułatwia to identyfikację wąskich gardeł, priorytetyzację zadań i poprawę efektywności operacyjnej. Wykresy Kanban i Gantta są praktyczne i skuteczne w zarządzaniu projektami Agile, tworzeniem oprogramowania i innymi procesami ciągłego doskonalenia.",
    loginConnect: "Łączyć",
    loginEmailOk: "Potwierdzać",
    loginText: "Login",
    loginEmailText: "Potwierdzenie e-mailem",
    loginMobileText: "Potwierdzenie mobilne",
    mobileConfirmInfoText: "Wysłano powiadomienie mobilne. Kliknij powiadomienie, aby potwierdzić proces logowania.",
    loginRightMore: "Więcej",
    loginHeaderP1: "Twoja korporacyjna pamięć",
    loginHeaderP2: "Ruchliwość",
    loginHeaderP3: "Moc graficzna",
    kanbanaddTasks: "Dodaj zadanie Kanban",
    tasksstatusDesciption: "Wyświetla nazwę kolumny, do której zostanie przypisane zadanie Kanban.",
    taskssubjectDescription: "Pozwala wprowadzić tytuł zadania Kanban. Tytuł Kanban jest polem wymaganym.",
    taskassignedToTask: "Grupy dodane do zadania",
    taskassignedTaskDescription: "Umożliwia wybór grup, które mają zostać przypisane do zadania kanban.",
    addedForTasks: "Dodano do zadania",
    taskAssignedInfoDescription: "Osoby do powiadomienia o zadaniu",
    assignedInfo: "Osoby, które mają zostać powiadomione",
    groupInfo: "Grupy, które mają zostać powiadomione o zadaniu",
    sortEnd: "Sortuj według daty zakończenia",
    sender: "Z",
    forward: "Do przodu",
    attachments: "Załączniki",
    taskdetailDescription: "Umożliwia wprowadzenie szczegółów zadania Kanban. Szczegóły zadania Kanban są polem wymaganym.",
    taskassignedDescription: "Umożliwia przypisanie użytkowników do zadania Kanban. Przynajmniej jeden użytkownik musi być przypisany do Kanban.",
    taskstartdateDescription: "Umożliwia wybór daty rozpoczęcia zadania Kanban. W Kanbanie data rozpoczęcia automatycznie przyjmuje godzinę utworzenia zadania.",
    taskenddateDescription: "Pozwala wybrać datę zakończenia zadania Kanban. W Kanbanie data zakończenia zadania jest automatycznie ustalana tydzień po utworzeniu zadania.",
    taskpriDescription: "Pozwala wybrać priorytet zadania Kanban. W Kanbanie termin wykonania zadania automatycznie przypada na tydzień po jego utworzeniu.",
    tagsDescription: "Umożliwia dodawanie tagów zadań Kanban. Tagi są oddzielone od siebie przecinkami podczas dodawania.",
    outlookDescription: "Po włączeniu opcji dodawania zadania do programu Outlook zadanie zostanie automatycznie dodane do kalendarza po zalogowaniu się na konto programu Outlook.",
    taskAssInfoDescription: "To pole jest używane dla osób, które nie są przypisane do zadania, ale których informacje są wymagane. Osoby dodane w celu informowania nie mogą podejmować działań w ramach zadań.",
    receiver: "Odbiornik",
    draft: "Projekt",
    spam: "Niepotrzebny e-mail",
    filterstate: "Filtruj według statusu",
    checkForspelling: "Sprawdź błędy ortograficzne",
    emailToForward: "Przekaż dalej e-mail",
    lowImpMails: "Wiadomości o niskim znaczeniu",
    normalImpMails: "Normalne Ważne Maile",
    highImpEmails: "Ważne wiadomości e-mail",
    showReadMails: "Pokaż przeczytane wiadomości",
    groupinfoDescription: "To pole jest używane w przypadku grup, które nie są przypisane do zadania, ale których informacje są wymagane. Osoby należące do grup dodanych w celu ich poinformowania nie mogą wykonywać operacji na zadaniach.",
    timeoutMission: "Czas rozpocząć alarm przed zakończeniem misji",
    timeoutmissionDescription: "Służy do określenia czasu rozpoczęcia alertu, gdy zadanie Kanban zbliża się do czasu zakończenia",
    taskperiodDescription: "Służy do określenia czasu okresowego przypomnienia, gdy zbliża się data zakończenia zadania kanban.",
    taskProgress: "Postęp zadania",
    taskProgressDescription: "Służy do wskazywania postępu zadania Kanban. Postęp można śledzić na wykresie Gantta.",
    updatekanbanTask: "Aktualizacja zadania Kanban",
    taskcreatorDescription: "Kanban pozwala na wyświetlenie autora zadania.",
    uploadfileDescription: "Służy do przesyłania plików do zadań Kanban. Pliki lub obrazy są rejestrowane w systemie DMS.",
    infoPersons: "Osoby do powiadomienia",
    warningtime: "Czas ostrzeżenia",
    taskPeriod: "Okres zadania",
    taskProgresSatus: "Postęp zadania",
    makeTask: "Twórca zadań",
    addedforTasks: "Dodano do zadania",
    outlookIntegration: "Integracja z Outlookiem",
    loginoutlook: "Zaloguj się do kalendarza Outlook",
    fetchoutlook: "Pobierz dane z kalendarza programu Outlook",
    progressStatus: "Status postępu",
    taskColors: "Kolory zadań",
    addcalendarTask: "Dodawanie zadań do kalendarza",
    updatetaskCalendar: "Aktualizacja zadania kalendarza",
    statusComplete: "Status ukończenia filtra",
    priorityFilter: "Filtrowanie priorytetowe",
    columnFilter: "Filtrowanie kolumn",
    assignPerson: "Przypisane osoby",
    assignGroup: "Przypisane grupy",
    noTask: "Nie znaleziono zadań",
    resetSort: "Resetuj sortowanie",
    sortASC: "Sortuj od A do Z",
    sortDESC: "Sortuj od Z do A",
    sortAppointment: "Sortuj według daty przypisania",
    trash: "Śmieci",
    showOlderMail: "Pokaż starszą pocztę",
    mailNotFound: "Poczta nie znaleziona",
    sendNewMail: "Wyślij nową pocztę",
    showUnreadMails: "Pokaż nieprzeczytane wiadomości",
    updateColumnMail: "Wiadomość do kontaktu po dodaniu zadania do kolumny",
    addTaskToOutlook: "Dodaj zadanie do programu Outlook",
    enterYourMessage: "Wpisz swoją wiadomość",
    reminder: "Przypomnienie",
    determinedToTask: "Czas określony dla zadania",
    remainingTime: "Pozostały czas",
    hours: "Godzina",
    withoutPriority: "Brak priorytetu",
    lowPri: "Niski priorytet",
    normalPri: "Średni priorytet",
    highPri: "Wysoki priorytet",
    showAllTasks: "Pokaż wszystko",
    showIncompleteTasks: "Pokaż niekompletne",
    showCompeletedTasks: "Pokaż ukończone",
    reportDesigner: "Projektant raportów",
    fileManagementSystem: "System zarządzania plikami",
    formDesigner: "Projektant formularzy",
    boardDesigner: "Projektant płytek",
    themeSettings: "Właściwości motywu",
    social: "Społeczny",
    profile: "Profil",
    contacts: "Łączność",
    files: "Akta",
    pages: "Strony",
    noResultsFound: "Nie znaleziono wyników",
    processes: "Procesy",
    filterByStatus: "Filtruj według statusu",
    filterByPri: "Filtruj według priorytetu",
    filterByCol: "Filtruj według kolumny",
    todoAddTasks: "Dodaj zadania do wykonania",
    addLabel: "Wprowadź etykietę",
    showWithSubTasks: "Pokaż podzadania",
    riverBoard: "Deski rzeczne",
    notify: "Powiadomienia",
    likedYourPost: "Polubiłem Twój post",
    likedYourComment: "Podobał mi się Twój komentarz",
    systemNotify: "Powiadomienia systemowe",
    readAllNotify: "Przeczytaj wszystkie powiadomienia",
    recommendedUsers: "Polecane osoby",
    suggestedPosts: "Sugerowane posty",
    sPostReposted: "Opublikowano ponownie",
    shareSomething: "Podziel się czymś",
    updatePost: "Aktualizacja posta",
    ifYouDoNotSelectGroup: "Jeśli nie wybierzesz grupy, Twój post będzie mógł zobaczyć każdy",
    addComment: "Dodaj komentarz",
    sendComment: "Wyślij komentarz",
    areYouSureYouWantToDeleteThisPost: "Czy na pewno chcesz usunąć post?",
    yes: "Tak",
    no: "NIE",
    deletePost: "Usuń post",
    postSuccesfullyDeleted: "Post pomyślnie usunięty",
    deleteComment: "Usuń komentarz",
    areYouSureYouWantToDeleteThisComment: "Czy na pewno chcesz usunąć ten komentarz?",
    commentSuccesfullyDeleted: "Komentarz pomyślnie usunięty",
    sharePost: "Udostępnij post",
    areYouSureYouWantToShareThisPost: "Czy na pewno chcesz udostępnić ten post?",
    repostedSuccessfully: "Opublikowano ponownie pomyślnie",
    upload: "Wgrywać",
    refresh: "Odświeżać",
    allowedExtentions: "Dozwolone rozszerzenia: JPG, GIF lub PNG. Maksymalny rozmiar pliku",
    systemLandingPagePreference: "Preferencje dotyczące strony docelowej",
    allownonadminuserstosearchforotherusers: "Zezwalaj użytkownikom bez uprawnień administratora na wyszukiwanie innych użytkowników",
    passwordChange: "Zmiana hasła",
    newPassword: "Nowe hasło",
    retypethenewpassword: "Wpisz ponownie nowe hasło",
    notifications: "Powiadomienia",
    showWhoLikesYourPost: "Pokaż, kto lubi Twoje posty",
    showWhoLikesYourComment: "Pokaż, kto lubi Twoje komentarze",
    aboutMe: "O mnie",
    bio: "Biografia",
    dateOfBirth: "Data urodzenia",
    website: "Strona internetowa",
    phone: "telefon",
    saveChanges: "Zapisz zmiany",
    username: "Nazwa użytkownika",
    content: "Treść",
    projectManagement: "Zarządzanie projektami",
    addPage: "Dodaj stronę",
    addFolder: "Dodaj folder",
    showUsers: "Użytkownicy, którzy mogą widzieć",
    showGroups: "Grupy, które mogą widzieć",
    readonlyUsers: "Tylko do odczytu (użytkownicy)",
    readonlyGroups: "Tylko do odczytu (grupy)",
    columnHeight: "Wysokość kolumny",
    showKanbanCount: "Pokaż informacje o ilości Kanban",
    kanbanSettings: "Ustawienia Kanban",
    gantSettings: "Ustawienia Ganta",
    schedulerSettings: "Ustawienia kalendarza",
    showRowLines: "Pokaż linie Linie",
    activateOutlookConnection: "Aktywuj połączenie Outlook",
    selectOutlookColumn: "Wybierz kolumnę Outlook",
    selectSMTPopoverText: "Wybrano opcję Poczta SMTP, która ma być używana w komponentach Kanban, Gantt, Kalendarz lub To-Do.",
    menuFilePathId: "Identyfikator folderu River Menu",
    recycleBinPathName: "Nazwa folderu na śmieci rzeczne",
    recycleBinPathId: "Identyfikator folderu River Trash",
    fileNameChangedMessage: "Nazwa pliku została pomyślnie zmieniona.",
    fileNameChangedErrorMessage: "Nie można zmienić nazwy pliku.",
    fileCreatedMessage: "Plik został pomyślnie utworzony.",
    newTaskMailDetailPopoverText: "Gdy nowe zadanie zostanie przypisane do komponentów Kanban, Gantt, Kalendarz lub To-Do, część zawartości wiadomości e-mail zostanie dodana do automatycznej wiadomości e-mail wysyłanej do przypisanych użytkowników.",
    taskOnDropMailPopoverText: "Część zawartości wiadomości e-mail, która zostanie dodana do automatycznej wiadomości e-mail wysyłanej do komponentów Kanban, Gantt, Kalendarz lub To-Do po zmianie kolumny zawierającej zadanie.",
    createdBy: "Twórca",
    updatedBy: "Zaktualizowano",
    createdDate: "Data utworzenia",
    updatedDate: "Data aktualizacji",
    folderPermissionSettings: "Ustawienia autoryzacji plików",
    quantity: "Sztuka",
    fileManagementPermissionSettings: "Ustawienia uprawnień zarządzania plikami",
    fileNotFoundErrorText: "Nie znaleziono plików spełniających kryteria wyszukiwania.",
    fileSearchInfoText: "Poszukiwania są w toku",
    updateTaskMailDetailPopoverText: "Część treści wiadomości e-mail, która ma zostać dodana do automatycznej wiadomości e-mail wysyłanej do przypisanych użytkowników po wprowadzeniu zmiany w powiązanym zadaniu w komponentach Kanban, Gantt, Kalendarz lub To-Do.",
    deleteTaskMailDetailPopoverText: "Część treści wiadomości e-mail, która ma zostać dodana do automatycznej wiadomości e-mail, która zostanie wysłana do przypisanych użytkowników po usunięciu powiązanego zadania w komponentach Kanban, Gantt, Kalendarz lub To-Do.",
    completeTaskMailDetailPopoverText: "Część treści wiadomości e-mail, która ma zostać dodana do automatycznej wiadomości e-mail, która zostanie wysłana do przypisanych użytkowników po ukończeniu powiązanego zadania w komponentach Kanban, Gantt, Kalendarz lub To-Do.",
    selectOutlookColumnPopoverText: "Wybrano kolumnę, w której mają zostać uwzględnione zadania dodawane za pośrednictwem programu Outlook.",
    createFolder: "Utwórz plik",
    versionHistory: "Historia wersji",
    subFileManager: "Menedżer plików podrzędnych",
    removeSubFiles: "Usuń plik podrzędny",
    parentFolder: "Folder nadrzędny",
    deletePermanently: "Usuń trwale",
    recover: "Odzyskiwać",
    groupPermissions: "Uprawnienia grupy",
    allowUpload: "Zezwól na przesyłanie plików",
    allowView: "Zezwól na przeglądanie plików",
    allowDownload: "Zezwól na pobieranie pliku",
    permissionType: "Typ uprawnienia",
    applyToSubFolders: "Zastosuj do wszystkich podfolderów",
    newFolderName: "Nowa nazwa pliku",
    tagTips: "Tagi muszą być poprzedzone znakiem #. Mogą zawierać tylko cyfry i znaki.",
    addAsNewVersion: "Zainstaluj jako nową wersję",
    addAndChangeName: "Prześlij ze zmianą nazwy",
    skip: "Pominąć",
    fileExistError: "Plik o tej samej nazwie istnieje w folderze docelowym",
    processFileShow: "Pokaż folder procesu rzecznego",
    processFilePathName: "Nazwa folderu River Process",
    processFilePathId: "Identyfikator folderu River Process",
    menuFileShow: "Pokaż folder menu rzeki",
    menuFilePathName: "Nazwa folderu menu rzeki",
    fileCreatedErrorMessage: "Utworzenie pliku nie powiodło się.",
    fileDeletedessage: "Usuwanie pliku zakończone.",
    fileDeletedErrorMessage: "Nie udało się usunąć pliku.",
    fileMovedMessage: "Przenoszenie pliku zakończone.",
    fileMovedErrorMessage: "Przenoszenie pliku nie powiodło się.",
    fileCopyMessage: "Kopiowanie pliku ukończone.",
    fileCopyErrorMessage: "Operacja kopiowania pliku nie powiodła się.",
    fileDownloadMessage: "Pobieranie pliku ukończone.",
    fileDownloadErrorMessage: "Pobieranie pliku nie powiodło się.",
    fileSizeShowErrorMessage: "Nie można wyświetlić, ponieważ rozmiar pliku jest duży. Proszę pobrać plik.",
    unsupportedFile: "Nieobsługiwany plik",
    fileNameError: "Istnieje plik o tej nazwie, spróbuj ponownie pod inną nazwą",
    fileGivePermissionMessage: "Autoryzacja pliku została ukończona pomyślnie.",
    fileGivePermissionErrorMessage: "Błąd autoryzacji pliku. Rejestracja nie powiodła się.",
    groupName: "Nazwa grupy",
    createGroup: "Utwórz grupę",
    conversation: "Rozmowy",
    startConversation: "Rozpocznij rozmowę",
    userNotFound: "Kontakt nie znaleziony",
    chatNotFound: "Czat nie został znaleziony",
    themeTypeLight: "Światło",
    themeTypeBorderedLight: "Oprawiony",
    themeHalfDark: "Półmrok",
    themeDark: "Ciemny",
    themeRouteAnimation: "Animacja przejścia",
    themeRouteAnimationFadeInLeft: "Lewe zanikanie",
    themeRouteAnimationZoomIn: "Brzęczenie",
    themeRouteAnimationFadeIn: "Znikać",
    themeRouteAnimationNone: "Nic",
    themeMenuType: "Typ menu",
    themeMenuTypeHorizontal: "Poziomy",
    themeMenuTypeVertical: "Pionowy",
    themeMenuCollapse: "Wąskie menu",
    themeMenuHidden: "Ukryte menu",
    themeNavbarColor: "Kolor paska nawigacyjnego",
    themeNavbarType: "Typ paska nawigacyjnego",
    themeSticky: "Lepki",
    themeStatic: "Statyczny",
    themeFloating: "Ruchomy",
    themeHidden: "Ukryty",
    themeFooterType: "Typ stopki",
    catalog: "Katalog",
    riverBoards: "Deski rzeczne",
    clipboardDesigner: "Projektant schowka",
    designMode: "Jesteś w trybie projektowania",
    editPage: "Edytuj stronę",
    rename: "Przemianować",
    exportToPdf: "Wyjście jako PDF",
    exportToExcel: "Wyjście jako Excel",
    revenueReport: "Raport przychodów",
    header: "Tytuł",
    connection: "Połączenie",
    primaryKey: "Klucz podstawowy",
    secondaryKey: "Klucz drugorzędny",
    completedKey: "Klucz ukończony",
    countKey: "Klucz zliczający",
    statusKey: "Klucz statusu",
    progressConnection: "Połączenie postępu",
    progressScript: "Skrypt postępu",
    progressPrimaryKey: "Klucz podstawowy postępu",
    progressCountKey: "Klucz postępu",
    progressPercentageKey: "Klucz postępu procentowego",
    progressColorKey: "Klucz kolorów postępu",
    keyColumn: "Kolumna wartości",
    currency: "Waluta",
    whitePage: "Biała strona",
    noReportSelected: "Nie wybrano raportu",
    noTypeSelected: "Nie wybrano typu raportu",
    whitePageReports: "Raport Białej Strony",
    addBranch: "Dodaj podział/podpodział",
    branchName: "Nazwa awarii",
    rowNumber: "Numer sekwencyjny",
    reportTypeSelect: "Wybierz typ raportu",
    reportDescription: "Opis raportu...",
    useWeb: "Użyj w sieci",
    useMobile: "Użyj na urządzeniu mobilnym",
    mainScript: "Główny skrypt",
    prerunScript: "Uruchomić skrypt wstępny?",
    preScript: "Nakaz",
    testIt: "Test",
    selectAll: "Zaznacz wszystko",
    addReport: "Dodaj raport",
    selectReportType: "Wybierz typ raportu",
    reportType: "Typ raportu",
    reportDesingPermission: "Użytkownik nie ma uprawnień do projektowania raportów.",
    reportImportedOpenLeftMenu: "Raport zaimportowany. Możesz otworzyć z menu po lewej stronie.",
    forReportExport: "Aby wyeksportować raport, musisz najpierw wybrać raport.",
    anErrorOccurred: "Wystąpił błąd",
    reportDeleted: "Raport usunięty",
    branchDeleted: "Usunięta awaria",
    addBranchName: "Proszę wpisać nazwę awarii",
    addedBranch: "Dodano oddział",
    selectConnectionAddress: "Proszę wybrać adres połączenia",
    enterSqlScript: "Proszę wpisać skrypt SQL",
    enterReportName: "Proszę podać nazwę raportu",
    reportAdded: "Dodano raport",
    numberOfDataToBeProcessed: "Połączenie pomyślne. Liczba danych do przetworzenia:",
    dataNotFoundCheckYourConnection: "Nie znaleziono danych! Sprawdź połączenie i polecenie SQL.",
    connectionNotFoundCheckYourConnection: "Połączenie nieudane! Sprawdź połączenie i polecenie SQL.",
    fillConnectionAndSql: "Proszę wypełnić swoje połączenie i polecenie SQL",
    allTypesActivate: "Wszystkie typy aktywują się w momencie wyświetlania",
    passwordRequired: "Wymagane jest hasło",
    showLess: "Pokaż mniej",
    showMore: "Pokaż więcej",
    authority: "Władza",
    preScriptDescription: "Opis recepty",
    enterReportFilters: "Wprowadź filtry raportu",
    gridDesigner: "Projektant siatki",
    addMainBranch: "Dodaj główne rozbicie",
    resetSettings: "Resetuj ustawienia",
    columsToGroup: "Użyj menu kontekstowego kolumn nagłówka, aby grupować dane",
    customize: "Dostosuj",
    colorType: "Typ koloru",
    formatManagement: "Zarządzanie formatami",
    bottomTotalColumn: "Dolna kolumna sumy",
    formatType: "Typ formatu",
    datagridSettingsReset: "Ustawienia siatki danych zostaną zresetowane",
    unexpectedError: "Przepraszamy, wystąpił nieoczekiwany błąd.",
    changesSaved: "Zmiany zostały zapisane",
    addGantTask: "Dodaj zadanie Ganta",
    updGantTask: "Aktualizacja zadania Ganta",
    updSchedulerTask: "Aktualizuj zadanie kalendarza",
    updTodoTask: "Aktualizuj zadanie do wykonania",
    completeTask: "Wykonaj zadanie",
    cantBeEmptyKanban: "Tytuł zadania, szczegóły zadania i osoba przypisana do zadania nie mogą być puste",
    successAdd: "Zadanie zostało pomyślnie dodane",
    successUpd: "Zadanie zostało pomyślnie zaktualizowane",
    errorReadonlyUpd: "Nie możesz zaktualizować zadania, ponieważ nie masz uprawnień.",
    errorCompletedUpd: "Nie można zaktualizować ukończonego zadania.",
    statusChangeTodo: "Status ukończenia zadania został pomyślnie zmieniony.",
    reminderSended: "Przypomnienie e-mailem o pomyślnym wysłaniu zadania",
    askForCompleteTask: "Czy na pewno chcesz wykonać zadanie?",
    infoForCompletedTask: "Podzadania Twojego zadania również zostaną ukończone.",
    noPermisison: "Nie masz uprawnień.",
    successDependencyAdded: "Zależność zadania została pomyślnie dodana",
    filterimportant: "Filtruj według ważności",
    enterEmail: "Podaj adres e-mail",
    reply: "Odpowiedź",
    newCol: "Nowa kolumna",
    thickness: "Grubość",
    distanceToUpperComponent: "Odległość do górnego składnika",
    companyName: "Nazwa firmy",
    showEmailModule: "Pokaż moduł e-mail",
    distanceToBottomComponent: "Odległość od dolnego elementu",
    canNonAdminUsersPost: "Czy użytkownicy bez uprawnień administratora mogą publikować?",
    columnColor: "Kolor kolumny",
    byWho: "przez",
    updated: "Zaktualizowano",
    commentAdded: "Komentarz dodany",
    completed: "Zrobione",
    addRemoveColumns: "Dodaj/Usuń kolumny",
    searchMessage: "Szukaj wiadomości",
    riverReports: "Raporty River BI",
    forms: "Formularze",
    searchinProcess: "Szukaj w procesach",
    searchVoiceMessage: "Wiadomość, której szukasz, znajduje się w tym pliku audio",
    searchVoiceMessages: "Przeszukiwanie poczty głosowej",
    showSocialNotifications: "Pokaż powiadomienia społecznościowe",
    showProjectManagementNotifications: "Pokaż powiadomienia dotyczące zarządzania projektami",
    showProcessNotifications: "Pokaż powiadomienia o procesach",
    pageDesingPermission: "Użytkownik nie ma uprawnień do projektowania strony.",
    filemanagementDesingPermission: "Użytkownik nie ma uprawnień do zarządzania plikami.",
    taskDelete: "Zadanie zostanie usunięte.",
    tasksWillDeleted: "Czy na pewno chcesz usunąć zadanie?",
    componentSettings: "Ustawienia komponentu",
    aboutComponent: "O komponencie",
    sureSaveChanges: "Czy na pewno chcesz zapisać zmiany?",
    showDeletedNotifications: "Pokaż powiadomienia, które usunąłem",
    shareSometthing: "Podziel się czymś",
    resetPageLayout: "Resetuj układ strony",
    downloadingSS: "Pobieranie zrzutu ekranu. Proszę czekać.",
    showHorizontalLines: "Pokaż linie poziome",
    turnOffVerticalHide: "Wyłącz ukrywanie pionowe",
    whichVerticalLinesAreToBeHidden: "Które linie pionowe mają być ukryte",
    priority: "Priorytet",
    desingMode: "Jesteś w trybie projektowania",
    boardSidebarMessageField: "Pole wiadomości zadania",
    boardSidebarExtraField: "Pole dodatkowego komponentu zadania",
    boardSidebarTaskHistory: "Historia zadań",
    loadMoreNotifications: "Pokaż więcej powiadomień",
    deletedNotifications: "Usunięte powiadomienia",
    noFormNotification: "Brak powiadomień o procesach",
    noDeletedFormNotifications: "Brak powiadomień o usuniętych procesach",
    noDeletedBoardNotification: "Brak powiadomień o usuniętych tablicach",
    noBoardNotification: "Brak powiadomień zarządu",
    noDeletedSocialNotification: "Brak usuniętych powiadomień z mediów społecznościowych",
    noSocialNotification: "Brak powiadomień z mediów społecznościowych",
    deleteAll: "Usuń wszystko",
    markAllRead: "Oznacz wszystkie jako przeczytane",
    board: "Tablica",
    form: "Formularz",
    formNotifications: "Powiadomienia formularza",
    boardNotifications: "Powiadomienia zarządu",
    socialNotifications: "Powiadomienia społecznościowe",
    email: "E-mail",
    oldFormName: "Stara nazwa formularza",
    newFormName: "Nowa nazwa formularza",
    oldFormVariable: "Stara zmienna formularza",
    newFormVariable: "Nowa zmienna formularza",
    oldCategory: "Stara kategoria",
    newCategory: "Nowa kategoria",
    connectionInFile: "Połączenie w pliku",
    yourConnection: "Twoje połączenie",
    element: "Element",
    script: "Scenariusz",
    formClosingEvent: "Wydarzenie zamykające formularz",
    message: "Wiadomość",
    formExportTextError: "Do formularza nie dodano żadnych komponentów lub formularz nie został zapisany. Rozwiąż ten problem, aby zapobiec niepowodzeniu operacji.",
    checkRequiedFields: "Zaznacz wymagane pola",
    dontCheckRequiredFields: "Nie zaznaczaj pól wymaganych",
    createPdfWarning: "Jeśli zaznaczone, formularz nie zostanie zapisany i zamknięty",
    cratePdf: "Utwórz plik PDF",
    identityNumber: "Numer identyfikacyjny",
    minPaymentHour: "Min. godzina",
    maxPaymentHour: "Maksymalna godzina",
    darkBlue: "Ciemnoniebieski",
    orange: "Pomarańczowy",
    component: "Część",
    properties: "Właściwości",
    dmsPath: "Ścieżka DMS",
    dashboard: "Panel",
    slider: "Suwak",
    list: "Lista",
    otherImages: "Inne obrazy",
    unitScript: "Skrypt jednostki",
    updatableMaxQuantity: "Maksymalna ilość do aktualizacji",
    newPage: "Nowa strona",
    code: "Kod",
    resetHiddenComponent: "Resetuj wartość ukrytych komponentów docelowych",
    bold: "Pogrubiony",
    italic: "italski",
    stringFormat: "Format ciągu",
    videoUploaded: "Wideo przesłane",
    fillInAllFields: "Wypełnij wszystkie pola",
    normalPaging: "Normalne stronicowanie",
    pageSize: "Rozmiar strony",
    special: "Specjalny",
    link: "Połączyć",
    fontWeight: "Grubość czcionki",
    fontFamily: "Rodzina czcionek",
    pdfFileNotFound: "Nie znaleziono pliku PDF",
    likedOn: "Polubione na",
    subCategory: "Podkategoria",
    toTheBoard: "do zarządu",
    changeTasksPage: "Görevin Panosunu Değiştir",
    hideTaskDetail: "Ukryj szczegóły zadania",
    selectData: "Wybierz dane",
    noContentYet: "Brak jeszcze treści",
    addRowBetween: "Dodaj wiersz pomiędzy",
    userPermissions: "Uprawnienia użytkownika",
    askForPassword: "Zapytać o hasło?",
    passwordIsWrong: "Hasło jest nieprawidłowe. Spróbuj ponownie.",
    pleaseEnterPassword: "Proszę podać hasło, aby kontynuować.",
    onePaymentEachSave: "Jedna płatność za każde zapisanie",
    riverModules: "Moduły RIVER",
    processHistory: "Historia procesu",
    commentHasBeenMadeAtThisStage: "Na tym etapie dodano komentarz",
    clearSelection: "Wyczyść zaznaczenie",
    allowDownloadVersionHistoryDocuments: "Zezwalaj na pobieranie dokumentów historii wersji",
    addNewColor: "Dodaj nową kolumnę",
    delegated: "Delegowany",
    openDocxToPdf: "Otwórz plik jako PDF",
    activationStartDate: "Data rozpoczęcia aktywacji",
    activationEndDate: "Data zakończenia aktywacji",
    changeActivationDate: "Zmień datę aktywacji",
    showArchive: "Pokaż archiwum",
    hideArchive: "Ukryj archiwum",
    tasks: "Zadania",
    maxFileCountLimit: "Maksymalna liczba plików",
    fileCountLimit: "Limit liczby plików",
    numberOfFilesExceeded: "Przekroczono liczbę plików",
    numberOfFilesLimit: "Limit liczby plików",
    lineIntermediateAllowAdd: "Dodaj linię pośrednią",
    lineIntermediateAllowCopy: "Kopiuj linię pośrednią",
    triggerReport: "Raport wyzwalający",
    setWhitePageReportExportName: "Ustaw nazwę eksportu raportu białej strony",
    menuRowUpdated: "Istnieją rekordy z wartością automatycznie zwiększaną. Numer automatycznie zwiększany został zaktualizowany:",
    isMenuRowControl: "Kontrola automatycznego zwiększania",
    sqlScriptWarning: "Użycie tego pola może spowodować spadek wydajności.",
    deletedTask: "Usunięte zadanie",
    getDeletedTasks: "Pobierz usunięte zadania",
    getTasks: "Pobierz zadania",
    movePageDesignersNode: "Wybrana tablica/menu zostanie przeniesiona do folderu",
    informationAboutMoveToDirectory: "Uprawnienia użytkownika przeniesionej tablicy/menu zmienią się zależnie od uprawnień folderu, do którego zostanie przeniesiona.",
    move: "Przenosić",
    download: "Pobierać",
    create: "Tworzyć",
    statistic: "Statystyka",
    priRate: "Współczynnik przypisania według priorytetu",
    taskcreatorlist: "Lista twórców zadań",
    completionRate: "Wskaźnik ukończenia",
    columnsTaskCount: "Liczba zadań w kolumnach",
    showKanbanFilter: "Pokaż filtry Kanban",
    showFileHistory: "Pokaż historię plików",
    processToStart: "Proces do rozpoczęcia",
    fieldMatching: "Dopasowanie pola",
    dontLetDeleteWhatTheyAdded: "Mogą usunąć to, co dodali",
    myJobs: "Moje prace",
    excelExportName: "Nazwa eksportu Excela",
    filterSearch: "Szukaj w zadaniach",
    filterForAssignUsers: "Filtruj według osoby przypisanej",
    filterForAssignUGroups: "Filtruj według grupy",
    filterForPri: "Filtruj według priorytetu",
    clearFilter: "Wyczyść filtry",
    makeReadOnly: "Ustaw jako tylko do odczytu",
    letItWorkProcessContinues: "Niech to zadziała, gdy proces będzie kontynuowany",
    event: "Wydarzenie",
    selectEvent: "Wybierz wydarzenie",
    rowEditor: "Edytor wierszy",
    formOpeningComponentEvent: "Wydarzenie komponentu otwierającego formularz",
    addedTask: "w dodatku",
    updatedTask: "zaktualizowano",
    messageAddedToTask: "Wiadomość dodana",
    deleteTask: "usunięto",
    completedTask: "zakończony",
    boardToastNotification: "Zadanie {{0}} {{3}} o nazwie {{2}} do wejścia na pokład {{1}}",
    socialToastNotification: "{{0}} polubił(a) Twój post z treścią {{1}} w {{2}}",
    repostToastNotification: "{{0}} opublikował(a) ponownie Twój post",
    isReposted: "ponownie opublikowano Twój post.",
    processToastNotification: "{{0}} skomentował formularz {{1}}",
    yesterday: "Wczoraj",
    today: "Dzisiaj",
    notSaved: "Nie zapisano",
    editors: "Redaktorzy",
    basic: "Podstawowy",
    file: "Plik",
    datagridPreferences: "Preferencje Datagrid",
    deleteLetsAsk: "Usunąć? - zapytajmy.",
    addNewRow: "Bez pytania dodaj jako nowy wiersz",
    oldRowShouldBeDeleted: "Bez pytania usuń stare wiersze",
    canBeSearched: "Czy można przeszukać?",
    processName: "Nazwa procesu",
    removeReadOnly: "Usuń właściwość tylko do odczytu",
    dontMakeRequired: "Nie wypełniaj pola wymaganego",
    generalSettings: "Ustawienia ogólne",
    pageDesignerFirstPage: "Pierwsza strona",
    beginDayHour: "Początek dnia",
    endDayHour: "Zakończenie dnia",
    dayTimeDuration: "Czas trwania",
    colorSettings: "Ustawienia kolorów",
    colorSettingsDescription: "Kolor tła danych.",
    dataName: "Nazwa danych",
    margin: "Margines",
    rowCount: "Liczba wierszy",
    colCount: "Liczba kolumn",
    outsideMargin: "Margines zewnętrzny",
    widgetName: "Nazwa widżetu",
    searchInProcess: "Formularze procesów",
    changeEventScriptRun: "Czy skrypty zmian powinny być uruchamiane po wypełnieniu danych?",
    dontChanceId: "(Tego identyfikatora obiektu nie można zmienić, ponieważ jest on używany w działaniach formularza komponentu.)",
    scriptButtonWarning: "Ustawienia statusu przycisku skryptu nie są obsługiwane w formularzach menu.",
    infiniteScroll: "Nieskończony Przewijanie",
    scrollSettings: "Ustawienia przewijania",
    pageNameSetting: "Sayfa Adı Ayarları",
    showPageName: "Sayfa Adını Göster",
    bindProcess: "Powiąż proces z tą stroną",
    bindProcessDetail: "Po powiązaniu procesu ze stroną, strona będzie dostępna tylko do odczytu. Zmiany na stronie można edytować tylko za pośrednictwem procesu. Formularz procesu otwiera się podczas edycji danych strony.",
    description2: "Opis 2",
    showJobListTabs: "Pokaż zakładki listy zadań",
    showUserPhotosInJobList: "Pokaż zdjęcia użytkowników na liście zadań",
    dmsVideoGaleryTabWarning: "Nie masz uprawnień do korzystania z tego pola.",
    searchInFormJson: "Wyszukaj w formularzu json",
    useExpandedJoblist: "Użyj rozszerzonej listy zadań",
    editTour: "Edytuj wycieczkę",
    saveAllForm: "Aktualizuj wszystkie formularze",
    selectComponent: "Wybierz komponent",
    tourComponents: "Komponenty wycieczki",
    addTourElement: "Dodaj element wycieczki",
    startTourWhenFormOpen: "Rozpocznij wycieczkę po otwarciu formularza",
    compare: "Porównywać",
    tourWillDeleted: "Wycieczka zostanie usunięta",
    deleteTourElement: "Usuń element wycieczki",
    tourDelete: "Usuń wycieczkę",
    fixedRowHeight: "Stała wysokość rzędu",
    pushWidgetItems: "Elementy widżetu Push",
    allowMultiLayer: "Zezwalaj na wielowarstwowość",
    gridType: "Typ siatki",
    useCollapsedJoblist: "Użyj zwiniętej listy zadań",
    searchAllData: "Wyszukaj wszystkie dane",
    scriptsRunAllAreSelected: "Czy skrypty mają być uruchamiane po wybraniu wszystkich?",
    menuSchedulerPermission: "Nie masz uprawnień do dodawania karty menu",
    showOnTask: "Czy edytor powinien być widoczny w procesach?",
    showAsPopupOnTrigger: "Ukryty w formularzu, pokaż jako popup po wyzwoleniu danych",
    alreadyHaveMenu: "Jeśli chcesz użyć komponentu menu, w formularzu musi znajdować się tylko jeden komponent menu i nie możesz dodać więcej niż jednego komponentu menu.",
    select: "Wybierać",
    startedUserName: "Nazwa użytkownika początkowego",
    startedUserId: "Rozpoczęto identyfikator użytkownika",
    processInstanceId: "Identyfikator instancji procesu",
    formId: "Identyfikator formularza",
    min: "Minimum",
    difference: "Zmiany między dwoma plikami",
    labelNotFound: "Etykieta nie jest zdefiniowana w tym języku",
    cleanElement: "Wyczyścić pole elementu podczas drukowania danych?",
    cleanColumn: "Czy zwolnić miejsce w kolumnie podczas drukowania danych?",
    fileSkippedSuccessfully: "Odwołany.",
    dmsTags: "Etykietka",
    searchInFormContents: "Wyszukaj w treści formularza",
    jobType: "Rodzaj pracy",
    workStatus: "Status pracy",
    sendMailManager: "Wyślij e-mail do menedżerów wybranych użytkowników",
    or: "Lub",
    signInWithMicrosoft: "Zaloguj się za pomocą konta Microsoft",
    receipt: "Paragon",
    receiptOptions: "Opcje paragonu",
    tax: "Podatek",
    selectboxWarningMessage: "Jeśli dane przekraczają 100, użyj komponentu wyszukiwania. Wyświetlanych jest pierwszych 100 wartości.",
    degree: "Stopień",
    completeDateShort: "Comp.Dt:",
    confirmationPopupClose: "Jeżeli nie podejmiesz żadnych działań, okno potwierdzenia zamknie się automatycznie.",
    confirmationSecondsSetting: "Ustawienie sekund w oknie potwierdzenia",
    createPdfAndSendForm: "Czy formularz powinien zostać wysłany po utworzeniu pliku PDF?",
    confirmCreatePdfAndSendForm: "Zostanie utworzony plik PDF i formularz zostanie wysłany. Czy potwierdzasz?",
    onlyNumbersError: "Należy wprowadzić wartość zawierającą wyłącznie liczby.",
    _filter: "Filtr",
    removeFromFavorites: "Usuń z ulubionych",
    addToFavorites: "Dodaj do ulubionych",
    id: "ID",
    assignedUserName: "Przypisana nazwa użytkownika",
    schemeId: "Identyfikator schematu",
    formStatusByUser: "Status formularza według użytkownika",
    formSituationByUser: "Sytuacja formularza według użytkownika",
    isDelegated: "Jest delegowany",
    formname: "Nazwa formularza",
    formstatus: "Status formularza",
    timeOutDate: "Data przekroczenia limitu czasu",
    saveFilterPack: "Zapisz pakiet filtrów",
    enterRegistrationName: "Wprowadź nazwę rejestracyjną",
    filterPackages: "Filtruj pakiety",
    speechLengthError: "Przemówienie jest dłuższe niż wymagana długość.",
    removeImage: "Usunąć",
    headerBundle: "Pakiet nagłówkowy",
    other: "Inny",
    verticalHeader: "Nagłówek pionowy",
    exportDataAuth: "Zezwolenia eksportowe",
    errorFileType: "Typ pliku jest nieprawidłowy. Akceptowany typ pliku:",
    folder: "Falcówka",
    page: "Strona",
    uploadPdfToDms: "Przesyłanie wygenerowanego pliku PDF do DMS",
    uploadPdfToDmsName: "Wprowadź nazwę pliku PDF, który chcesz zapisać w DMS.",
    pdfName: "Nazwa pliku PDF",
    addTour: "Dodaj wycieczkę",
    updateTour: "Aktualizacja wycieczki",
    editTourElement: "Edytuj element wycieczki",
    buttonAction: "Akcja przycisku",
    referenceArea: "Obszar odniesienia",
    fieldToFill: "Pole do wypełnienia",
    buttonColor: "Kolor przycisku",
    signFile: "Podpisz plik",
    eSignFile: "Podpisz za pomocą cyfrowego podpisu elektronicznego",
    addNewCategory: "Dodaj nową kategorię",
    autoRefreshJoblist: "Lista zadań odświeża się automatycznie",
    changeScriptRow: "Zmień kolejność skryptów",
    defaultRowCheckRequired: "Czy wymagane sprawdzenia pól powinny być wykonywane, gdy istnieje wiersz domyślny?",
    currentCode: "Aktualny kod",
    screenshotOnMobile: "Robienie zrzutu ekranu na urządzeniu mobilnym",
    showCallElement: "Pokaż przycisk połączenia",
    created: "Stworzony",
    keepPermission: "Przenieś uprawnienia podczas przenoszenia formularza. (Niezalecane, jeśli użytkownicy lub grupy nie są takie same)",
    showAddComponentButtonOnDragMenu: "Czy przycisk dodawania powinien być wyświetlany w lewym menu przeciągania?",
    editCategory: "Zmień nazwę kategorii",
    confirmDeleteCategory: "Usuń kategorię",
    formsWillMoveOnGeneral: "Formularze znajdujące się w usuniętej kategorii zostaną automatycznie przeniesione do folderu „Ogólne”.",
    disabledDates: "Daty wyłączone",
    fileLimitAndSizeRequired: "Rozmiar pliku lub limit pliku nie mogą być puste",
    relatedFieldChangeDetected: "Wykryto powiązaną zmianę danych. Wartość została wyczyszczona.",
    toastAnonimFormEmailWarning: "W formularzach anonimowych wymagany jest komponent e-mail.",
    toastAnonimFormEmailControlWarning: "Gdy pole Formularz logowania jest aktywne, pole Adres e-mail nie może pozostać puste.",
    startTrigger: "Uruchom wyzwalacz",
    stopTrigger: "Zatrzymaj spust",
    poll: "Głosowanie",
    quickPoll: "Szybka ankieta",
    pollTitle: "Tytuł ankiety",
    questionSection: "Sekcja pytań",
    options: "Opcje",
    enterYourQuestion: "Wpisz swoje pytanie",
    option: "Opcja",
    addOption: "Dodaj opcję",
    selectGroups: "Wybierz grupy",
    yourQuestionWillAppearHere: "Twoje pytanie pojawi się tutaj",
    optionText: "Tekst opcji",
    pollVisibility: "Widoczność ankiety",
    visibleAnytime: "Zawsze widoczny",
    visibleAfterExpiration: "Widoczne po wygaśnięciu",
    isPostDeleted: "Post został usunięty",
    totalVotes: "Łączna liczba głosów",
    pollHasEnded: "Ankieta zakończona",
    pollResults: "Wyniki ankiety",
    objectFit: "Dopasowanie obiektu",
    areYouSureForClosing: "Czy na pewno chcesz zamknąć?",
    retweet: "Retweet",
    retweetNotAllowed: "Retweetowanie jest niedozwolone",
    postHasBeenDeleted: "Post został usunięty",
    post: "Post",
    pollType: "Typ ankiety",
    retweetConfirmation: "Czy na pewno chcesz retweetować ten post?",
    addYourThoughts: "Dodaj swoje przemyślenia...",
    postContentTooLong: "Treść posta nie może przekraczać 500 znaków",
    pollResultsVisibleAfterExpiration: "Wyniki będą widoczne po zakończeniu ankiety",
    pollResultsAnonymous: "Ankieta jest anonimowa. Wyniki nie są widoczne.",
    generalPoll: "Ankieta ogólna",
    components: "Komponenty",
    tabComponents: "Składniki karty",
    allowFloating: "Zezwalaj na pływanie",
    cellAspectRatio: "Współczynnik kształtu komórki",
    cellSpacing: "Odstępy między komórkami",
    selectedCardSettings: "Wybrane ustawienia karty",
    panelSettings: "Ustawienia panelu",
    cannotDragMoreWidget: "Nie można dodać więcej niż jednego widżetu do karty.",
    carouselSpeed: "Prędkość karuzeli (ms)",
    carouselMaxPauseOnHover: "Maksymalna pauza po najechaniu kursorem (ms)",
    noContentInThisTab: "Do tej zakładki nie dodano jeszcze żadnej treści.",
    pageTypeNotSelected: "Nie wybrano typu strony. Żadna treść nie zostanie wyświetlona.",
    folderSelectionWarning: "Wybrano folder. Żadna zawartość nie zostanie wyświetlona.",
    menuDisplayUnsupported: "Wyświetlanie menu nie jest obsługiwane w projektancie stron.",
    noPageSelected: "Nie wybrano żadnej strony",
    design: "Projekt",
    addCard: "Dodaj kartę",
    createFlowInfo: "Przepływ został pomyślnie uruchomiony",
    flowRestartedSuccessfully: "Przepływ został pomyślnie ponownie uruchomiony",
    flowIsSuccessfullyResumed: "Przepływ został pomyślnie wznowiony",
    noSettingsForThisWidget: "Brak ustawień dla tego widżetu",
    taskHistoryWarning: "Nie znaleziono historii procesu!",
    channels: "Kanallar",
    defaultAndFollowed: "Domyślne i śledzone",
    following: "następny",
    publicChannels: "Kanały publiczne",
    privateChannels: "Prywatne kanały",
    followRequests: "Śledź żądania",
    invitationRequests: "Prośby o zaproszenia",
    noInvitationRequests: "Brak próśb o zaproszenie",
    votes: "Głosy",
    inviteUsers: "Zaproś użytkowników",
    channelType: "Typ kanału",
    displayName: "Nazwa wyświetlana",
    editChannel: "Edytuj kanał",
    noFollowRequests: "Brak próśb o obserwowanie",
    unfollow: "Przestań obserwować",
    follow: "Podążać",
    cantFollowYourself: "Nie możesz podążać za sobą",
    requestSent: "Prośba wysłana",
    cancelRequest: "Anuluj prośbę",
    wantsToFollowYou: "Chce za tobą podążać",
    youInvitedToFollow: "Zostałeś zaproszony do obserwowania",
    accept: "Przyjąć",
    defaultChannelTypeInfo: "Informacje o domyślnym typie kanału",
    enterChannelDescription: "Wprowadź opis kanału",
    createDefaultChannel: "Utwórz kanał domyślny",
    channelInformation: "Informacje o kanale",
    channelDescription: "Opis kanału",
    members: "Członkowie",
    filteredChannels: "Filtrowane kanały",
    pollNotAnswerable: "W tej chwili nie można odpowiedzieć na tę ankietę",
    errorLoadingPollResults: "Błąd ładowania wyników ankiety",
    openEndedResponses: "Odpowiedzi otwarte",
    noPollResponses: "Brak odpowiedzi",
    noPollData: "Brak dostępnych danych z ankiety",
    activePolls: "Aktywne ankiety",
    pinnedPost: "Przypięty post",
    pinPost: "Przypnij post",
    unpinPost: "Odepnij post",
    reposted: "Opublikowano ponownie",
    originalPostDeleted: "Oryginalny post został usunięty",
    videoNotSupported: "Wideo nie jest obsługiwane",
    comments: "Uwagi",
    writeComment: "Napisz komentarz",
    filePreviewNotAvailable: "Podgląd pliku niedostępny",
    downloadFile: "Pobierz plik",
    imageNotAvailable: "Obraz niedostępny",
    back: "Z powrotem",
    pollValidation: "Tytuł ankiety musi mieć co najmniej 3 znaki",
    questionValidation: "Tekst pytania musi mieć co najmniej 5 znaków",
    noSuggestedPosts: "Brak sugerowanych postów",
    noRecommendedUsers: "Brak polecanych użytkowników",
    postSavedSuccessfully: "Post zapisany pomyślnie",
    errorSavingPost: "Wystąpił błąd podczas zapisywania posta",
    contentCannotBeEmpty: "Zawartość nie może być pusta",
    onlyAdminsCanPost: "Tylko administratorzy mogą publikować",
    duplicateOptionsNotAllowed: "Duplikowanie opcji jest niedozwolone",
    pleaseCompleteAllFields: "Proszę wypełnić wszystkie pola",
    errorCreatingPoll: "Wystąpił błąd podczas tworzenia ankiety",
    upcoming: "Nadchodzące",
    channelNameRequired: "Nazwa kanału jest wymagana",
    errorLoadingUsers: "Błąd ładowania użytkowników",
    selectAnalyticPage: "Wybierz stronę analityczną",
    allChannelTypes: "Wszystkie typy kanałów",
    changePassword: "Zmieniono hasło",
    postLiked: "Post polubiony",
    commentAddedSuccessfully: "Komentarz dodano pomyślnie",
    anonymous: "Anonimowy",
    postUnliked: "Post polubiony",
    commentLiked: "Komentarz polubiony",
    errorToggleCommentLike: "Wystąpił błąd podczas przełączania komentarza, np.",
    channelName: "Nazwa kanału",
    createdAt: "Utworzono w",
    security: "Bezpieczeństwo",
    iisAddress: "Adres IIS",
    sessionTimeout: "Przekroczenie limitu czasu sesji",
    jwtTimeout: "Przekroczenie limitu czasu JWT",
    vrfFactor: "Współczynnik weryfikacji",
    syncFactor: "Współczynnik synchronizacji",
    companySettings: "Ustawienia firmy",
    companyLogo: "Logo firmy (dane:zawartość/typ;base64)",
    companyLogoLogin: "Ekran logowania do logo firmy (data:content/type;base64)",
    companyLoginBackground: "Tło ekranu logowania firmy (data:content/type;base64)",
    communicationSettings: "Ustawienia komunikacji",
    smtpAddressID: "Identyfikator adresu SMTP",
    logEmails: "Dzienniki e-mail",
    adDomainName: "Nazwa domeny Active Directory",
    adUserName: "Nazwa użytkownika usługi Active Directory",
    adPassword: "Hasło usługi Active Directory",
    adLogonType: "Typ logowania do usługi Active Directory",
    adKrbProvider: "Dostawca Kerberos dla usługi Active Directory",
    adLoginType: "Metoda logowania do usługi Active Directory",
    hasLDAP: "Czy posiada integrację LDAP?",
    english: "angielski",
    turkish: "turecki",
    specialCodeDescripts: "Opisy kodów specjalnych",
    receiptHtml: "Zawartość HTML paragonu",
    exchangeRateCodes: "Kody kursów walut",
    customMenuData: "Dane menu niestandardowego",
    forceBGScripts: "Wymuś skrypty tła",
    canPost: "Można wysłać",
    canSearchUsers: "Czy można wyszukiwać użytkowników",
    mobileTwoFactorAuth: "Mobilne uwierzytelnianie dwuskładnikowe",
    allowUserSearch: "Zezwolić użytkownikom na wyszukiwanie?",
    definition: "Definicja",
    smtpAddress: "Adres SMTP",
    emailAddress: "Adres e-mail",
    useSSL: "Użyj SSL",
    editMailSettings: "Edytuj ustawienia e-mail",
    newMailSettings: "Nowe ustawienia poczty e-mail",
    exchangeServerDomain: "Domena serwera Exchange",
    noSSLPort: "Port bez protokołu SSL",
    sslOpAllowUnsafeLegacyRenegotiationProt: "Zezwalaj na niebezpieczną renegocjację starszego protokołu SSL",
    emailPassword: "Hasło do poczty e-mail",
    mailSettingsUpdatedSuccessfully: "Ustawienia poczty zostały pomyślnie zaktualizowane",
    mailSettingsAddedSuccessfully: "Ustawienia poczty zostały pomyślnie dodane",
    deleteMailSettingsConfirmation: "Czy na pewno chcesz usunąć ustawienia poczty?",
    mailSettingsDeletedSuccessfully: "Ustawienia poczty zostały pomyślnie usunięte",
    pleaseCheckRequiredFields: "Proszę zaznaczyć pola obowiązkowe",
    dbSettingsCreatedSuccessfully: "Ustawienia bazy danych zostały pomyślnie utworzone",
    editDBSettings: "Edytuj ustawienia bazy danych",
    newDBSettings: "Nowe ustawienia bazy danych",
    deleteDBSettingsConfirmation: "Czy na pewno chcesz usunąć ustawienia bazy danych?",
    dbSettingsDeletedSuccessfully: "Ustawienia bazy danych zostały pomyślnie usunięte",
    dbSettingsUpdatedSuccessfully: "Ustawienia bazy danych zostały pomyślnie zaktualizowane",
    newIntegrationSettings: "Nowe ustawienia integracji",
    editIntegrationSettings: "Edytuj ustawienia integracji",
    integrationSettingsCreatedSuccessfully: "Ustawienia integracji zostały pomyślnie utworzone",
    integrationSettingsUpdatedSuccessfully: "Ustawienia integracji zostały pomyślnie zaktualizowane",
    deleteIntegrationSettingsConfirmation: "Czy na pewno chcesz usunąć ustawienia integracji?",
    integrationSettingsDeletedSuccessfully: "Ustawienia integracji zostały pomyślnie usunięte",
    notFoundPassword: "Nie znaleziono ustawień hasła w bazie danych. Proszę je zapisać.",
    minCharacter: "Minimalna liczba znaków",
    passwordChangeFrequency: "Częstotliwość zmiany hasła (dni)",
    passwordComplexity: "Poziom bezpieczeństwa hasła",
    mixedCaseLetters: "Wielkie i małe litery",
    specialCharacter: "Znak specjalny",
    requireADigit: "Wymagana cyfra?",
    passwordCriteria: "Kryteria hasła",
    smsToken: "Token SMS",
    smsUsername: "Nazwa użytkownika SMS",
    smsPassword: "Hasło SMS",
    smsServiceName: "Nazwa usługi SMS",
    smsPhoneNumber: "Numer telefonu SMS",
    gmapToken: "Token Map Google",
    gtrToken: "Token GTR",
    gmlToken: "Token GML",
    gfrbToken: "Token GFRB",
    gdbToken: "Token GDB",
    gdbName: "Nazwa GDB",
    loginFeaType: "Typ funkcji logowania",
    microsoftAuthenticator: "Microsoft Authenticator",
    loginWithoutLook: "Zaloguj się bez patrzenia",
    activeDirectory: "Usługa Active Directory",
    sslPort: "Port SSL",
    loginTfaType: "Logowanie Dwuskładnikowe uwierzytelnianie typu",
    voteSuccessful: "Głos został pomyślnie przesłany",
    errorSubmittingVote: "Wystąpił błąd podczas przesyłania głosu",
    pollExpired: "Ankieta wygasła",
    voteUpdated: "Twój głos został pomyślnie zaktualizowany",
    errorUpdatingVote: "Wystąpił błąd podczas aktualizacji Twojego głosu",
    groupNameWarning: "Nie można utworzyć grupy o tej samej nazwie!",
    exit: "Wyjście",
    leaveChatGroup: "Opuść grupę",
    clearChatMessage: "Wyczyść czat",
    groupMember: "Członkowie grupy",
    addMember: "Dodaj członka",
    chatClearWarning: "Czat został pomyślnie wyczyszczony.",
    leaveGroupWarning: "Pomyślnie opuściłeś grupę.",
    groupNameUserWarning: "Nazwa grupy i członkowie grupy nie mogą być puści!",
    fileSizeWarning: "Rozmiar pliku nie może przekraczać 100 KB.",
    groupMemberRemove: "Członek grupy został pomyślnie usunięty.",
    addGroupMemberWarning: "Członek grupy został pomyślnie dodany.",
    goToPasswordChangePanel: "Przejdź do panelu zmiany hasła",
    minFileCountLimit: "Minimalna liczba plików",
    minimumFileRequired: "Nie osiągnięto minimalnej liczby plików",
    headerSettings: "Ustawienia nagłówka",
    wordWrap: "Zawijanie wierszy"
  }
}
